import React from 'react';

const TimetablePreferenceContext = React.createContext();

export default TimetablePreferenceContext;